import type { FlexProps } from '@chakra-ui/react';
import { Button, Flex, Icon } from '@chakra-ui/react';
import { ArrowBack, ArrowForward } from '@veno-app/icons';

export type SlideButtonProps = FlexProps & {
  onPrev: () => void;
  onNext: () => void;
  isPrevDisabled?: boolean;
  isNextDisabled?: boolean;
};
export const SlideButton = ({
  onPrev,
  onNext,
  isPrevDisabled,
  isNextDisabled,
  ...props
}: SlideButtonProps) => {
  return (
    <Flex gap="15px" {...props}>
      <Button
        variant="raised"
        size="xs"
        onClick={onPrev}
        isDisabled={isPrevDisabled}
      >
        <Icon as={ArrowBack} boxSize="18px" />
      </Button>
      <Button
        variant="raised"
        size="xs"
        onClick={onNext}
        isDisabled={isNextDisabled}
      >
        <Icon as={ArrowForward} boxSize="18px" />
      </Button>
    </Flex>
  );
};
